import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import ReactDOM from 'react-dom';
import { useDocumentTitle } from '@mantine/hooks';
import { IconHelp, IconX } from '@tabler/icons-react';
import { HeaderMenu } from "../../components/HeaderMenu/HeaderMenu";
import { notifications } from '@mantine/notifications';
import { Container, Skeleton, Card, Group, Text, Button, Grid, Pagination, Accordion, Flex, Select } from '@mantine/core';
import classes from '../DashBoard/DashBoard.module.css';
import './ReviewingTest.css';
import { SelectTooltip } from "../../components/GeneralComponent/GeneralComponent";
import { DiscardDraft } from "../../components/CreateTest/DiscardDraft";
import { GridPage } from "../../components/CreateTest/GridPage";
import { PageList } from "../../components/CreateTest/PageList";
import { GridRotationPage } from "../../components/CreateTest/GridRotationPage";
import { AddTest } from "../../components/CreateTest/AddTest";
import { TestTypes } from "../../components/CreateTest/TestTypes";
import { PageOptions } from "../../components/CreateTest/PageOptions";
import TestsApi from "../../api/TestsApi";

export function CreateTest() {
	const navigate = useNavigate();
	useDocumentTitle("Visiopt - Create Test");
	const [selectedMemberWebsite, setSelectedMemberWebsite] = useState('');
	const [selectTestType, setSelectTestType] = useState('');
	const [accordionItemDefaultValue, setAccordionItemDefaultValue] = useState("step-1");
	const [step2, setStep2] = useState("none");
	const [step3, setStep3] = useState("none");
	const [step4, setStep4] = useState("none");

	const testIconRef = useRef(null);
	const testTypeIconRef = useRef(null);
	const step1IconRef = useRef(null);
	const step4IconRef = useRef(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [helpTargetId, setHelpTargetId] = useState(0);
  const [tooltipPosition, setTooltipPosition] = useState({});

	const handleHeaderMenuComponentChange = (Value:any) => {
	  setSelectedMemberWebsite(Value);
	};

	const ContinueTestEditor = (pageId:any) => {
		if(selectTestType === ''){
			notifications.show({
        color: 'red',
        icon: <IconX size="1.1rem" />,
        title: 'Error',
        message: "Please select a test!",
      });
		} else {
			navigate(`/test-editor-visual/${selectedThumbnail}/${selectTestType}`);
		}
	};
  const [loading, setLoading] = useState(false);
	const [selectedAllCreateTestPageValue, setSelectedAllCreateTestPageValue] = useState('0');
	const [activePageNo, setActivePageNo] = useState(1);
	const [keyword, setKeyword] = useState('');
	const [selectPageCreateTests, setSelectPageCreateTests] = useState([]);
	const [modernabSplitTest, setModernabSplitTest] = useState('');
	const [singleVariableTest, setSingleVariableTest] = useState('');
	const [classicabSplitTest, setClassicabSplitTest] = useState('');
	const [totalPages, setTotalPages] = useState(10);
	const [totalPaginationNo, setTotalPaginationNo] = useState(1);
	const [selectedThumbnail, setSelectedThumbnail] = useState(null);
	const [selectedDraftThumbnail, setSelectedDraftThumbnail] = useState(null);
	const [isThumbnailSelected, setIsThumbnailSelected] = useState(false);
	const [isDraftThumbnailSelected, setIsDraftThumbnailSelected] = useState(false);
	const [selectedDraftPageId, setSelectedDraftPageId] = useState('');
	const [selectedDraftTaguchiTestId, setSelectedDraftTaguchiTestId] = useState('');
  const [viewSelect, setViewSelect] = useState('grid');
  const [showNumber, setShowNumber] = useState(25);
  const [selectedThumbnails, setSelectedThumbnails] = useState([]);

  const [funnelRotationOptions, setFunnelRotationOptions] = useState([]);
  const [rotationPageLists, setRotationPageLists] = useState([]);

  const [selectSmartRelationData, setSelectSmartRelationData] = useState([]);
  const [marksalestime, setMarksalestime] = useState(0);

  const [selectedFunnelRotation, setSelectedFunnelRotation] = useState(null);
  const [showContinueButton, setShowContinueButton] = useState(true);

  const [selectedFunnelValue, setSelectedFunnelValue] = useState("");
  const [isActiveTestSelected, setIsActiveTestSelected] = useState(false);
  const [activeTestsId, setActiveTestsId] = useState("");
  const [activeFunnelId, setActiveFunnelId] = useState("");
	useEffect(() => {
		if(selectedMemberWebsite !== ''){
      setLoading(true);
	    TestsApi.getcreatetestpagelist({
	      system_website_id: selectedMemberWebsite,
	      filter: selectedAllCreateTestPageValue,
	      layout: viewSelect,
	      number: showNumber,
	      page: activePageNo,
	      keyword: keyword,
	      selected_funnel: selectedFunnelValue
	    })
	    .then(response => {
	      if (response.ok) {
	        return response.json();
	      } else {
	        if (response.status === 401 || response.status === 400) {	          
	          navigate("/logout");
	        }
	      }
	    })
	    .then(data => {
	      if(data.status === 1){
          setLoading(false);
	        if (data.data.test_pages_list) {
	          setSelectPageCreateTests(data.data.test_pages_list);
	          setModernabSplitTest(data.data.modern_ab_split_test);
	          setSingleVariableTest(data.data.single_variable_test);
	          setClassicabSplitTest(data.data.classic_ab_split_test);
	          setShowContinueButton(data.data.show_continue_button);
	          if (data.data.active_page_no !== activePageNo) {
	            setActivePageNo(data.data.active_page_no);
	            setActivePageNo(1);
	          }
	          if (data.data.total_pages !== totalPages) {
	            setTotalPages(data.data.total_pages);
	          }
	          if (JSON.stringify(data.data.total_pagination_no) !== JSON.stringify(totalPaginationNo)) {
	            setTotalPaginationNo(data.data.total_pagination_no);
	          }
	        } else{
	          setSelectPageCreateTests([]);
	        }
	      }else{
	        setSelectedAllCreateTestPageValue('0');
					notifications.show({
	          color: 'red',
	          icon: <IconX size="1.1rem" />,
	          title: 'Error',
	          message: data.message,
	        });
          setLoading(false);
	      }	      
	    })
	    .catch(error => {
        setLoading(false);
	      console.error("API Error:", error);	      
	    });
	  }
  }, [selectedAllCreateTestPageValue, activePageNo, selectedMemberWebsite, viewSelect, showNumber, keyword, marksalestime, selectedFunnelValue]);

  const handlePageChange = (newPage) => {
    setActivePageNo(newPage);
  };

  const handleAddtoFunnel = async () => {
  	try {
  		if(isActiveTestSelected && selectedThumbnail !== null){
  			const APIResponse = await TestsApi.checkpageinfunnelvalidation({
	        page_id: selectedThumbnail,
	        taguchi_test_id: selectedDraftTaguchiTestId,
	        system_website_id : selectedMemberWebsite
	      });
	      const APIResultJSON = await APIResponse.json();
	      if (APIResultJSON.status === 1) {
	        navigate("/reviewing-test", { state: { pageId: selectedThumbnail, taguchiTestId: selectedDraftTaguchiTestId, funnelId:activeFunnelId, testsId:activeTestsId} });
	      }else{
	        notifications.show({
	          color: 'red',
	          icon: <IconX size="1.1rem" />,
	          title: 'Error',
	          message: APIResultJSON.message,
	        });
	      }
	    }
  		if(selectedDraftThumbnail === null && selectedThumbnail === null){
  			notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: "Please Select a Page",
        });
  		}
  		if(selectedDraftThumbnail !== null){
  			const APIResponse = await TestsApi.checkpageinfunnelvalidation({
	        system_website_id : selectedMemberWebsite,
	        page_id: selectedDraftThumbnail
	      });
	      const APIResultJSON = await APIResponse.json();
	      if (APIResultJSON.status === 1) {
	      	if(singleVariableTest === selectedDraftTaguchiTestId){
	      		navigate(`/test-editor-visual/${selectedDraftPageId}/${selectedDraftTaguchiTestId}`);
	      	} else if(modernabSplitTest === selectedDraftTaguchiTestId){
	      		navigate(`/test-editor-visual-modern/${selectedDraftPageId}/${selectedDraftTaguchiTestId}`);
	      	} else {
	      		navigate(`/test-editor-visual/${selectedDraftPageId}/${selectedDraftTaguchiTestId}`);
	      	}
	      }else{
	        notifications.show({
	          color: 'red',
	          icon: <IconX size="1.1rem" />,
	          title: 'Error',
	          message: APIResultJSON.message,
	        });
	      }
  		} 

  		if (selectedThumbnail !== null) {
  			const APIResponse = await TestsApi.checkpageinfunnelvalidation({
	        system_website_id : selectedMemberWebsite,
	        page_id: selectedThumbnail
	      });
	      const APIResultJSON = await APIResponse.json();
	      if (APIResultJSON.status === 1) {
      	 if (document.activeElement instanceof HTMLElement) {
				    document.activeElement.blur();
				  }
	      	setStep2("block");
					setAccordionItemDefaultValue("step-2");
	      }else{
	        notifications.show({
	          color: 'red',
	          icon: <IconX size="1.1rem" />,
	          title: 'Error',
	          message: APIResultJSON.message,
	        });
	      }
  		}
    } catch (error) {
      console.error("API Error:", error);
    }
  }


	const funnelRotationData = funnelRotationOptions.map((FunnelRotation) => ({
	  value: FunnelRotation.funnel_id,
	  label: FunnelRotation.name,
	}));

	const handleFunnelRotationChange = (value) => {
    setSelectedFunnelRotation(value);
    setSelectedThumbnails([]);
    TestsApi.getfunnelinrotation({
      system_website_id: selectedMemberWebsite,
      page_id:selectedThumbnail,
      funnel_id:value
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if (data.status === 1) {
        setRotationPageLists(data.data.data || []);
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });
  };

  // Default to the first funnel ONLY when the funnel list itself is (re)loaded.
  // It must depend on the funnelRotationOptions state, not on the derived
  // funnelRotationData array: that array is rebuilt on every render, so the effect
  // re-ran after every render and snapped the user's manual funnel choice back to
  // the first funnel, leaving the dropdown out of sync with the loaded pages and
  // sending the wrong funnel_id to the rotation-page validation / save APIs.
  useEffect(() => {
	  if (funnelRotationOptions.length > 0) {
	  	setSelectedFunnelRotation(funnelRotationOptions[0].funnel_id);
	  	setSelectedThumbnails([]);
	  }
	}, [funnelRotationOptions]);

	const SelectSmartRelationalTest = (value:any) => {
		setSelectTestType(value);
	};

	const handleHelpClick = (id:any) => {
    setShowHelpModal(true);
    setHelpTargetId(id);
    const iconRefMapping = {
    	13: testTypeIconRef,
    	24: step4IconRef,
    	120: testIconRef,
    	14: step1IconRef
    };
    const iconRef =  iconRefMapping[id];
    if (iconRef.current) {
      const { top, left, width } = iconRef.current.getBoundingClientRect();
      const scrollOffset = window.scrollY;
      setTooltipPosition({
        [id]: {top: top + scrollOffset, left: left + width + 10},
      });
    }
  };

	return (
	  <>
	  {showHelpModal && Object.keys(tooltipPosition).map((key) => (
      ReactDOM.createPortal(
        <div>
          <SelectTooltip
		        isVisible={showHelpModal}
		        setIsVisible={setShowHelpModal}
		        id={helpTargetId}
		        tooltipPosition={tooltipPosition[key]}
		      />
        </div>,
      document.body
    )))}
	  <HeaderMenu HeaderMenuValue={selectedMemberWebsite} HeaderMenuOnChange={handleHeaderMenuComponentChange}/>
  	<Container size="xl">
  		<Card shadow="sm" padding="sm" radius="md" withBorder>
	  	  <Group position="apart" mb="xs">
	  	    <Text weight={500}>CREATE TEST </Text>
	  	  </Group>
	  	  <Container size="xl" px={0}>
	  	    <Accordion chevronPosition="right"  value={accordionItemDefaultValue} onChange={setAccordionItemDefaultValue} variant="separated">
	  	      <Accordion.Item className={classes.item} value="step-1">
	  	        <Accordion.Control><Text component="span" color="red" weight={500}>Step 1</Text><Text component="span" weight={500}> - Select a Page <IconHelp ref={testIconRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(120)}/></Text></Accordion.Control>
	  	        <Accordion.Panel>
	  	        	<PageOptions
	  	        		ViewSelect={viewSelect}
									ViewSelectChange={setViewSelect}
									ShowNumberChange={setShowNumber}
									ActivePageNo={setActivePageNo}
									SelectedTestPageValue={setSelectedAllCreateTestPageValue}
									selectedAllCreateTestPageValue={selectedAllCreateTestPageValue}
									KeywordChange={setKeyword}
									selectedFunnelValue={selectedFunnelValue}
									setSelectedFunnelValue={setSelectedFunnelValue}
									selectedMemberWebsite={selectedMemberWebsite}
	  	        	/>
          	    <div style={{flex: "1 1 auto",overflowX: "hidden",marginTop:10}}>
          	    	<div style={{ display: viewSelect === "grid" ? "block" : "none"}}>
                    {loading ? (
										  <Flex justify="start" gap="sm" mt={10} wrap="wrap">
										    {Array.from({ length: 21 }).map((_, index) => (
										      <Skeleton key={index} height={185} width={163} />
										    ))}
										  </Flex>
										) : (
										  <>
        					  <Grid ml={0} mt={10} mb={10} >
                      <GridPage
                        SelectedPageCreateTests={selectPageCreateTests}
                        SelectedThumbnail={selectedThumbnail}
                        SelectedThumbnailChange={setSelectedThumbnail}
                        SelectedDraftThumbnail={selectedDraftThumbnail}
                        SelectedDraftThumbnailChange={setSelectedDraftThumbnail}
                        DraftThumbnailIsSelected={isDraftThumbnailSelected}
                        DraftThumbnailIsSelectedChange={setIsDraftThumbnailSelected}
                        ThumbnailIsSelected={isThumbnailSelected}
                        ThumbnailIsSelectedChange={setIsThumbnailSelected}
                        SelectedDraftPageIdChange={setSelectedDraftPageId}
                        SelectedDraftTaguchiIdChange={setSelectedDraftTaguchiTestId}
                        setActiveTestsId={setActiveTestsId}
                        setActiveFunnelId={setActiveFunnelId}
                        setIsActiveTestSelected={setIsActiveTestSelected}
                      />
                    </Grid>
                    {selectPageCreateTests.some(item => Array.isArray(item) ? item.length > 0 : true) && (
        					  <Pagination.Root total={totalPages} value={activePageNo} onChange={handlePageChange} >
        					    <Group spacing={5} position="center">
        					      <Pagination.First />
        					      <Pagination.Previous />
        					      <Pagination.Items />
        					      <Pagination.Next />
        					      <Pagination.Last />
        					    </Group>
        					  </Pagination.Root>
                    )}
										  </>
										)}
        				  </div>
                  {selectPageCreateTests.some(item => Array.isArray(item) ? item.length > 0 : true) ? (
        				  <div style={{ display: viewSelect === "list" ? "block" : "none"}}>
        				  	{loading ? (
        				  		<Flex direction="column" gap="sm" mt={10}>
						            {Array.from({ length: 12 }).map((_, index) => (
						              <Skeleton key={index} height={44} width={1262} />
						            ))}
						          </Flex>
        				  	) : (
        				  		<>
        				  			<PageList
	                        SelectedPageCreateTests={selectPageCreateTests}
	                        SelectedThumbnail={selectedThumbnail}
	                        SelectedThumbnailChange={setSelectedThumbnail}
	                        SelectedDraftThumbnail={selectedDraftThumbnail}
	                        SelectedDraftThumbnailChange={setSelectedDraftThumbnail}
	                        DraftThumbnailIsSelected={isDraftThumbnailSelected}
	                        DraftThumbnailIsSelectedChange={setIsDraftThumbnailSelected}
	                        ThumbnailIsSelected={isThumbnailSelected}
	                        ThumbnailIsSelectedChange={setIsThumbnailSelected}
	                        SelectedDraftPageIdChange={setSelectedDraftPageId}
	                        SelectedDraftTaguchiIdChange={setSelectedDraftTaguchiTestId}
	                        selectedAllCreateTestPageValue={selectedAllCreateTestPageValue}
	                        setActiveTestsId={setActiveTestsId}
	                        setActiveFunnelId={setActiveFunnelId}
	                        setIsActiveTestSelected={setIsActiveTestSelected}
	                      />
	        		  	    <Pagination.Root total={totalPages} value={activePageNo} onChange={handlePageChange} >
	        		  	      <Group spacing={5} position="center">
	        		  	        <Pagination.First />
	        		  	        <Pagination.Previous />
	        		  	        <Pagination.Items />
	        		  	        <Pagination.Next />
	        		  	        <Pagination.Last />
	        		  	      </Group>
	        		  	    </Pagination.Root>
        				  		</>
        				  	)}
        				  </div>
                  ) : (
                  	<div style={{ display: viewSelect === "list" ? "block" : "none", height:180}}>
                  	</div>
                  )}
        			  </div>
        			  <div className="legend-holder">
        				  <Grid>
        				  	{showContinueButton && (
        				  		<Grid.Col span={6}>
	        		        	<Button type="button" onClick={() => handleAddtoFunnel()}>Continue</Button>
		        		        {selectedDraftThumbnail && (
	                        <DiscardDraft
	                          SelectedMemberWebsite={selectedMemberWebsite}
	                          SelectedDraftThumbnail={selectedDraftThumbnail}
	                          SelectedDraftThumbnailChange={setSelectedDraftThumbnail}
	                          SelectedDraftPageId={selectedDraftPageId}
	                          SalesMarkTimeChange={setMarksalestime}
	                        />
									    	)}
	        		        </Grid.Col>
        				  	)}
	        		      <Grid.Col span={3} offset={3} mt={6}> 
	        		        	<Flex gap="xs" align="center" mt={6}>
												  <span className="legend selected" /><Text size="sm" fz={12}>Selected</Text>
												  <span className="legend no-test" /><Text size="sm" fz={12}>No Test</Text>
												  <span className="legend draft" /><Text size="sm" fz={12}>Draft Test</Text>
												</Flex>
	        		      </Grid.Col>
        		      </Grid>
        			  </div>
	  	        </Accordion.Panel>
	  	      </Accordion.Item>
	  	      <Accordion.Item className={classes.item} value="step-2" style={{display:step2}}>
	  	        <Accordion.Control><Text component="span" color="red" weight={500}>Step 2</Text><Text component="span" weight={500}> - Select Test Type <IconHelp ref={testTypeIconRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(13)}/></Text></Accordion.Control>
	  	        <Accordion.Panel>
	  	        	<TestTypes
	  	        		SelectedMemberWebsite={selectedMemberWebsite}
									SelectedThumbnail={selectedThumbnail}
									ModernABSplitTest={modernabSplitTest}
									SingleVariableTest={singleVariableTest}
									SetStep3={setStep3} SetStep4={setStep4}
									SetLoading={setLoading}
									AccordionItemDefaultValueChange={setAccordionItemDefaultValue}
									FunnelRotationOptions={setFunnelRotationOptions}
									RotationPageLists={setRotationPageLists}
									SmartRelationsData={setSelectSmartRelationData}
	  	        	/>
	  	        </Accordion.Panel>
	  	      </Accordion.Item>
	  	      <Accordion.Item className={classes.item} value="step-3" style={{display:step3}}>
	  	        <Accordion.Control><Text component="span" color="red" weight={500}>Step 3</Text><Text component="span" weight={500}> - Select Rotataion Page <IconHelp ref={step1IconRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(14)}/></Text></Accordion.Control>
 	  	        <Accordion.Panel>
           	    <div style={{flex: "1 1 auto",overflowX: "hidden",marginTop:5}}>
 									<div style={{ display: 'flex',marginBottom:5}}>
					          <Text mt={5} mr={5}>Select Funnel:</Text><div style={{color:"red",marginTop:5}}>*</div>
					          <Select 
					            w={200}
					            ml={10}
					            value={selectedFunnelRotation}
					            onChange={handleFunnelRotationChange}
					            data={funnelRotationData}
					            searchable
					            nothingFound="No options"
					            maxDropdownHeight={300}
					          />
					        </div>
					        {/* Outer wrapper allows horizontal scrolling when the grid is wider than the viewport
					            (e.g. when the user zooms in). Inner Grid has minWidth fixed to 7 columns (7 * 176px)
					            so any tiny body-width change on Continue click cannot reflow it from 7 to 6 columns. */}
					        <div style={{ overflowX: 'auto' }}>
					        	<Grid ml={0} mt={10} mb={10} style={{ minWidth: 1232 }}>
                      <Skeleton visible={loading}>
                        <GridRotationPage
                        	SelectedMemberWebsite={selectedMemberWebsite}
                          selectedFunnelRotationPage={selectedFunnelRotation}
                          rotationGridPageLists={rotationPageLists}
                          SelectedThumbnail={selectedThumbnails}
                          SelectedThumbnailChange={setSelectedThumbnails}
                        />                                 
                      </Skeleton>
                    </Grid>
					        </div>
					        <div className="legend-holder">
					        	<Flex gap="xs" align="center" wrap="wrap" justify="flex-end">
					        	  <span className="legend selected" />
					        	  <Text size="sm" fz={12} className="legend-title">Selected</Text>
					        	  <span className="legend no-test" />
					        	  <Text size="sm" fz={12} className="legend-title">No Test</Text>
					        	  <span className="legend active" />
					        	  <Text size="sm" fz={12} className="legend-title">Active Test</Text>
					        	  <span className="legend draft" />
					        	  <Text size="sm" fz={12} className="legend-title">Draft Test</Text>
					        	  <span className="legend winner" />
					        	  <Text size="sm" fz={12} className="legend-title">Winner</Text>
					        	  <span className="legend rotation" />
					        	  <Text size="sm" fz={12} className="legend-title">Rotation Page</Text>
					        	</Flex>
					        </div>
	               	<AddTest
	                  SelectedMemberWebsite={selectedMemberWebsite}
	                  selectedFunnelRotationPage={selectedFunnelRotation}
                    SelectedThumbnails={selectedThumbnails}
                    SelectedThumbnail={selectedThumbnail}
                    ClassicAbSplitTest={classicabSplitTest}
	               	/>
         			  </div>
 	  	        </Accordion.Panel>
	  	      </Accordion.Item>
	  	      <Accordion.Item className={classes.item} value="step-4" style={{display:step4}}>
	  	        <Accordion.Control><Text component="span" color="red" weight={500}>Step 3</Text><Text component="span" weight={500}> - Select Smart Relational Test <IconHelp ref={step4IconRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(24)}/></Text></Accordion.Control>
  	        	<Accordion.Panel>
  	        		{loading ? (
  	        			<Skeleton visible={loading} height={750}>
  	        			</Skeleton>
  	        		) : (
  	        			<Group>
	  	        			{selectSmartRelationData.map((item) => (
							        <Card
							          key={item.taguchi_type_id}
							          withBorder
							          h={130}
							          py={6}
							          w={232}
							          className={item.taguchi_type_id === selectTestType ? "test_type_clicked" : ""}
							          onClick={() => SelectSmartRelationalTest(item.taguchi_type_id)}
	                      style={{cursor: 'pointer'}}
							        >
							          <Text weight={700}>{item.title}</Text>
							          <Text my={8} fz={12} weight={700}>{item.variables} VARIABLES</Text>
							          {item.numberofcount.map((count, index) => (
							            <div key={index} style={{ display: "flex" }}>
							              <Text fz={12} weight={700} mr={5}>{count.numberVars}</Text>
							              <Text fz={12} mr={5}>variables with</Text>
							              <Text fz={12} weight={700} mr={5}>{count.numberVers}</Text>
							              <Text fz={12}>versions</Text>
							            </div>
							          ))}
							        </Card>
							      ))}
	              	</Group>
  	        		)}
              	<Group>
              		<Button type="button" mt={10} onClick={() => ContinueTestEditor(selectedThumbnail)}>Continue</Button>
              	</Group>
  	        	</Accordion.Panel>
  	      	</Accordion.Item>
  	    	</Accordion>
	  	  </Container>
	  	</Card>
	  </Container>
	  </>
	);
}